<template>
	<div class="user-watches-group-form">
		<spinner v-if="group.loading"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-text v-model="model.name" name="group_name" :placeholder="$t('labels.general.name')" rules="required"/>
			<error-box v-if="form_error" :error="form_error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</div>
</template>

<script>
import FormTypes from './FormTypes'
import ApiObject from '@/classes/api/ApiObject'
import Group from '@/classes/Group'
export default {
	props: [
		'user_uid',
		'group_id',
		'action',
		'type'
	],
	data () {
		return {
			loading: false,
			form_error: null,
			model: {
				name: ''
			},
			group: new ApiObject()
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.action) {
				case 'add':
					this.addGroup()
					break
				case 'edit':
					this.editGroup()
					break
				default:
					this.$log.warn('group form', 'action not set')()
			}
		},
		getGroup () {
			const method = this.type === FormTypes.PATIENT ? this.$api.groups.patients.get : this.$api.groups.devices.get
			this.group.loading = true
			method(this, this.user_uid, this.group_id)
				.then(response => {
					this.$log.info('group form', 'groups.get OK', response)()
					this.group.data = new Group(response.body)
					this.model = this.group.data
				}).catch(error => {
					this.$log.error('group form', 'groups.get ERROR', error)()
					this.group.error = error
				}).finally(() => {
					this.group.loading = false
				})
		},
		addGroup () {
			const method = this.type === FormTypes.PATIENT ? this.$api.groups.patients.add : this.$api.groups.devices.add
			this.loading = true
			method(this, this.user_uid, this.model)
				.then(response => {
					this.$log.info('group form', 'groups.add OK', response)()
					this.$emit('done')
				}).catch(error => {
					this.$log.error('group form', 'groups.add ERROR', error)()
					this.form_error = error
				}).finally(() => {
					this.loading = false
				})
		},
		editGroup () {
			const method = this.type === FormTypes.PATIENT ? this.$api.groups.patients.edit : this.$api.groups.devices.edit
			this.loading = true
			method(this, this.user_uid, this.model)
				.then(response => {
					this.$log.info('group form', 'groups.edit OK', response)()
					this.$emit('done')
				}).catch(error => {
					this.$log.error('group form', 'groups.edit ERROR', error)()
					this.form_error = error
				}).finally(() => {
					this.loading = false
				})
		}
	},
	created () {
		if (this.action === 'edit') {
			this.getGroup()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesFormGroup.vue